<div id="resultsGroup" class="p-md-8 mw-1400 m-auto">
    <div class="header row-auto g-0">
        <div class="navigation col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="row">
                <div class="col">
                    <h2 class="results-title selenium-search-results-count" #title>
                        {{ resultsCount }} results in
                        <a
                            [routerLink]="['/collection', searchInfo.slug]"
                            [queryParams]="{ student: isStudent ? true : null }"
                            >{{ searchInfo.title }}</a
                        >
                        Collection
                    </h2>
                </div>
            </div>
            <div class="row-auto d-none d-sm-none d-md-block">
                <div class="col">
                    <a
                        class="go-to-search gtm-coll-search-goto-global-search"
                        [routerLink]="['/search']"
                        [queryParams]="{ student: isStudent ? true : null }"
                        queryParamsHandling="preserve"
                    >
                        Search all of PBS LearningMedia
                        <app-icon [type]="'Arrow-right2'"></app-icon>
                    </a>
                </div>
            </div>
            <div class="row">
                <div
                    *ngIf="didYouMeanSuggestions.highlighted"
                    class="selenium-search-results-suggestion spell col-xs-12 col-sm-12 col-md-12 col-lg-12"
                >
                    <span>Did you mean:</span>
                    <a (click)="onDidYouMeanClick()">
                        <i [innerHTML]="didYouMeanSuggestions.highlighted"></i>
                    </a>
                </div>
            </div>
            <div class="mobile-filters-wrapper d-md-none">
                <app-mobile-search-top-section
                    [searchInfo]="searchInfo"
                ></app-mobile-search-top-section>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 d-none d-sm-none d-md-block">
                    <app-applied-filters [searchInfo]="searchInfo"></app-applied-filters>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4">
                    <app-rank-by class="filter-wrapper" [isOnSearch]="true"></app-rank-by>
                </div>
            </div>
        </div>
    </div>
    <div class="search-group">
        <div class="search-group-inner">
            <div *ngIf="!loadingResults" class="search-items row">
                <div
                    class="search-item {{ bootstrapClasses }} selenium-search-results-item"
                    *ngFor="let learningObject of learningObjectResults"
                >
                    <app-collection-search-card
                        class="mb-6"
                        *ngIf="learningObject.isCollection"
                        [learningObject]="learningObject"
                        [gtmPrefix]="gtmPrefix"
                    >
                    </app-collection-search-card>
                    <app-resource-search-card
                        class="mb-6"
                        *ngIf="!learningObject.isCollection"
                        [learningObject]="learningObject"
                        [gtmPrefix]="gtmPrefix"
                    ></app-resource-search-card>
                </div>
            </div>

            <div *ngIf="loadingResults" class="search-items placeholder row">
                <div
                    class="search-item {{
                        bootstrapClasses
                    }} selenium-search-results-item-placeholder          "
                    *ngFor="let result of resultsPlaceholder"
                >
                    <app-element-placeholder [type]="'inline'"></app-element-placeholder>
                </div>
            </div>

            <app-pagination
                (goPage)="goToPage($event)"
                (goNext)="onNext()"
                (goPrev)="onPrev()"
                (goFirst)="onFirst()"
                (goLast)="onLast()"
                (click)="scrollTo(title)"
                [loading]="loadingResults"
                [pagesToShow]="7"
                [page]="currentPage"
                [perPage]="resultsPerPage"
                [count]="totalResultsForPagination"
            ></app-pagination>
            <a
                class="go-to-search-bottom gtm-coll-search-goto-global-search d-md-none"
                [routerLink]="['/search']"
                queryParamsHandling="preserve"
            >
                Search all of PBS LearningMedia
                <app-icon [type]="'Arrow-right2'"></app-icon>
            </a>
        </div>
    </div>
</div>
